// extracted by mini-css-extract-plugin
module.exports = {"ChatAssistant-container":"ChatAssistant_ChatAssistant-container__3VBJx","container-bubbles":"ChatAssistant_container-bubbles__2X8NI"};